import { useQuery } from '@apollo/client';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import Label from '../../components/foundations/Label';
import CopyToClipboardButton from '../../components/molecules/CopyToClipboardButton';
import { GET_ORGANIZATION_OPTIONS } from '../queries';
import { partnerShape } from './types';
import css from './PartnerId.css';

const PartnerId = ({ partner, className = '' }) => {
    const { data: organizationOptions } = useQuery(GET_ORGANIZATION_OPTIONS);

    if (!organizationOptions?.showAttributionPartnerName || !partner.attributionPartnerName) {
        return null;
    }

    return (
        <div className={classNames(css.partnerIdRow, className)}>
            <Label text="STATIC.PAGES.PARTNER_CONFIGURATION.PARTNER_ID_LABEL" className={css.partnerIdLabel} />
            <span className={css.partnerIdValue}>{partner.attributionPartnerName}</span>
            <CopyToClipboardButton
                textToCopy={partner.attributionPartnerName}
                labelTranslationKey="STATIC.BUTTONS.COPY"
                buttonClassName={css.copyButton}
            />
        </div>
    );
};

PartnerId.propTypes = {
    partner: partnerShape.isRequired,
    className: PropTypes.string,
};

export default PartnerId;
